import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import ReturnStepsLocations, {
    ReturnStepsLocationsData,
    ReturnStepsLocationsDataKeys,
    ReturnStepsLocationsDisplayOptions,
} from '../../../../components/return-steps-locations/ReturnStepsLocations';

const ReturnStepsLocationsColumnTemplate = (props: CellTemplateProps) => {
    const data = gridCellData(props);

    return (
        <React.Fragment>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <ReturnStepsLocations
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={data}
                        defaultProps={ReturnStepsLocationsColumnTemplateDefaultProps}
                    />
                )}
            </GridColumnInspectorHelper>
        </React.Fragment>
    );
};

export const ReturnStepsLocationsColumnTemplateDefaultProps =
    {} as ReturnStepsLocationsDisplayOptions;

export const ReturnStepsLocationsColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type ReturnStepsLocationsColumnTemplateData = ReturnStepsLocationsData & {};

export const ReturnStepsLocationsColumnTemplateDataKeys = [...ReturnStepsLocationsDataKeys];

export default ReturnStepsLocationsColumnTemplate;

